import React from 'react';

const AsyncAuthorProfile = React.lazy(() => import('./ProfileContainer'));

export const AuthorProfile = () => {
  return <AsyncAuthorProfile />;
};
